module.exports = __webpack_public_path__ + "img/digital1.be8bb8af.svg";